import { View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import type { ReactNode } from "react";
import { PrimaryControlsStripToolbar } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";

/**
 * Cookbook is experimental and off by default (Admin settings → Cookbook). Its drawer /
 * primary-nav entry points are hidden when disabled, so this only catches deep links and a
 * mounted tab after the setting is turned off. It renders a placeholder rather than redirecting,
 * because a blurred tab must never navigate on its own.
 */
export function CookbookAccessGate({ children }: { children: ReactNode }) {
  const [isCookbookEnabled] = useDeviceSetting("isCookbookEnabled");
  if (isCookbookEnabled) {
    return children;
  }
  return (
    <View
      className="flex-1 items-center justify-center bg-background px-8"
      testID="cookbook-unavailable"
    >
      <PrimaryControlsStripToolbar floating title="Cookbook" />
      <Text className="text-center text-base text-muted-foreground">
        Cookbook isn’t enabled. Turn it on in Admin settings.
      </Text>
    </View>
  );
}
